import React from 'react';
import PropTypes from 'prop-types';
import {Lock} from 'lucide-react';
import Box from '../box/box.jsx';
import Modal from '../../containers/modal.jsx';
import styles from './magblocks-modal.css';

const MagblocksAuthModal = ({onSignIn, onCancel}) => (
    <Modal
        className={styles.modalContent}
        contentLabel="Sign in to continue"
        id="magblocksAuth"
        onRequestClose={onCancel}
    >
        <Box className={styles.modalBody}>
            <div className={styles.authIcon}>
                <Lock
                    size={32}
                    strokeWidth={2}
                />
            </div>
            <p className={styles.authDescription}>
                {'This feature is only available to logged-in users. Sign in to save, load, and manage your projects.'}
            </p>
            <div className={styles.stackActions}>
                <button
                    className={styles.btnPrimary}
                    onClick={onSignIn}
                >
                    {'Login'}
                </button>
                <button
                    className={styles.btn}
                    onClick={onCancel}
                >
                    {'Continue as Guest'}
                </button>
            </div>
        </Box>
    </Modal>
);

MagblocksAuthModal.propTypes = {
    onSignIn: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
};

export default MagblocksAuthModal;
